var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading == true && _vm.value == 0)?_c('div',{staticClass:"icon-loader"}):_c('div',[(!Number.isNaN(_vm.value))?_c('span',[_vm._v(" "+_vm._s(_vm.value === 0 || _vm.value === "0" ? "-" : _vm.value)),(_vm.isPercentage && _vm.value !== 0)?_c('span',[_vm._v("%")]):_vm._e()]):_c('span',[_vm._v(" - ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }